import React, { useState } from 'react';
import Header from './Header/Header';
import Navigation from './Navigation/Navigation';
import classnames from 'classnames';

import './layout.scss';
import SidePopup from '../../Components/SidePopup/SidePopup';
import ProfilePopupForm from '../../Components/Forms/ProfilePopupForm/ProfilePopupForm';

const Layout = ({page, children, ...props}) => {

    const [myProfileState, setMyProfileState] = useState(false);

    return (
        <div className={classnames(["admin-layout", page])}>

            <Header
                toggleMyProfile={() => setMyProfileState(!myProfileState)}
            />

            <div className="container-fluid flex-1">
                <div className="row h-100">
                    <div className="col-2 p-0">
                        <Navigation />
                    </div>
                    <div className="main col-10">
                        {children}
                    </div>
                </div>
            </div>

            <SidePopup
                isOpen={myProfileState}
                toggleMyProfile={() => setMyProfileState(!myProfileState)}
            >
                <ProfilePopupForm/>
            </SidePopup>
        </div>
    );
};

export default Layout;
